module.exports = __webpack_public_path__ + "img/link02.98bfdb33.jpg";